export const FETCH_PACKAGE_STATUS_LIST_PENDING = "FETCH_PACKAGE_STATUS_LIST_PENDING";
export const FETCH_PACKAGE_STATUS_LIST_REJECTED = "FETCH_PACKAGE_STATUS_LIST_REJECTED";
export const FETCH_PACKAGE_STATUS_LIST_FULFILLED = "FETCH_PACKAGE_STATUS_LIST_FULFILLED";



// WEBPACK FOOTER //
// ./src/constants/packageStatuses.js